import axios from "../axios-auth";
import orginal_axios from "axios";

export const budgetService = {
    getBudgetHeaderList,
    saveBudget,
    getBudgetDetail,
    getBudgetExcelExport,
};

function getBudgetHeaderList(searchParams, page, size, sortedBy) {
    if (!page) {
        page = 0;
    } else {
        page -= 1;
    }
    if (!size) {
        size = 50;
    }

    let params = {
        page: page,
        size: size,
    };

    if (sortedBy != 'null,asc') {
        params["sort"] = sortedBy;
    }

    if (searchParams.fromDate) {
        params["fromDate"] = searchParams.fromDate;
    }
    if (searchParams.toDate) {
        params["toDate"] = searchParams.toDate;
    }
    if (searchParams.issueNo) {
        params["issueNo"] = searchParams.issueNo;
    }
    if (searchParams.shopId) {
        params["shopId"] = searchParams.shopId;
    }
    if (searchParams.financeSettingId) {
        params["financeSettingId"] = searchParams.financeSettingId;
    }
    if (typeof (searchParams.isAddDetails) === 'boolean') {
        params["isAddDetails"] = searchParams.isAddDetails;
    }

    return axios.get("/auth/budgets", { params });
}

function saveBudget(budget) {
    if (!budget.id) {
        // new budget
        return axios.post("/auth/budget", budget);
    } else {
        // edit
        return axios.put("/auth/budget", budget);
    }
}

function getBudgetDetail(id) {
    return axios.get("/auth/budget/" + id);
}

function getBudgetExcelExport(searchParams) {
    let params = {};

    if (searchParams.fromDate) {
        params["fromDate"] = searchParams.fromDate;
    }
    if (searchParams.toDate) {
        params["toDate"] = searchParams.toDate;
    }
    if (searchParams.issueNo) {
        params["issueNo"] = searchParams.issueNo;
    }
    if (searchParams.shopId) {
        params["shopId"] = searchParams.shopId;
    }
    if (searchParams.financeSettingId) {
        params["financeSettingId"] = searchParams.financeSettingId;
    }

    return orginal_axios({
        method: "GET",
        url: axios.defaults.baseURL + "/auth/export-all-budget-excel",
        params,
        responseType: "arraybuffer", // important
        headers: {
            Authorization: "Bearer " + localStorage.getItem("accessToken"),
            Accept: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            "Content-Type": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        }
    }).then(function (response) {
        return { blob: new Blob([response.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" }), headers: response.headers }
    });
}
